module.exports = __webpack_public_path__ + "static/vitanica-77ef022ccf2695e14d9d1c67ad77f86a.png";